/**
 * The wire shape `Rws.AiInsights.Host.Session.SessionLimitsEndpoints` returns: how long a signed-in portal session lasts.
 * Gated on `settings.write`. A change applies to every session at its next request.
 */
import { adminRequest, type AdminResult } from "./adminApi";

/** The two session limits, in the whole hours an administrator edits. */
export interface SessionLimits {
  /** The longest a session lasts from sign-in, in hours. */
  absoluteHours: number;
  /** How long a session survives without use, in hours. */
  idleHours: number;
  /** When the values were last saved, or `null` while the defaults apply. */
  updatedAt: string | null;
}

const sessionLimitsPath = "/api/entitlement/settings/session-limits";

/** Calls `GET /api/entitlement/settings/session-limits`. */
export async function fetchSessionLimits(): Promise<AdminResult<SessionLimits>> {
  return adminRequest<SessionLimits>(sessionLimitsPath, { method: "GET" }, "session limits");
}

/** Calls `PUT /api/entitlement/settings/session-limits`. */
export async function updateSessionLimits(absoluteHours: number, idleHours: number): Promise<AdminResult<SessionLimits>> {
  return adminRequest<SessionLimits>(
    sessionLimitsPath,
    { method: "PUT", body: JSON.stringify({ absoluteHours, idleHours }) },
    "session limits update",
  );
}
